import React, {  useEffect, useState } from 'react';
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
// @mui material components
import Card from "@mui/material/Card";
// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
// Soft UI Dashboard React components
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
// @mui material components
import Grid from "@mui/material/Grid";
import Swal from 'sweetalert2';

import IconSave from '@mui/icons-material/Save';
import IconBack from '@mui/icons-material/ArrowBack';
import IconSearch from '@mui/icons-material/Search';

//
import CuentasRequest from '../../../Repository/Cuentas';
import ModalBusqueda from '../ModalBusqueda';
import ButtonCancelarCuenta from './ButtonCancelarCuenta';
import ActionMenu from './ActionMenu';


function CuentaDetalle({ cuenta_uuid , onCloseViewDetalle, onMenuSelecteItem }) {

    const [cuenta, setCuenta] = useState({});
    const [alias, setAlias] = useState('');
    const [razon_social, setRazonSocial] = useState('');
    const [rfc, setRfc] = useState('');
    const [serie, setSerie] = useState('');
    const [nombreComercial, setNombreComercial] = useState('');

    const [isOpenModal, setIsOpenModal] = useState(false);
    const [uuidSelected, setUuidSelected] = useState('');
    const [customerSelected, setCustomerSelected] = useState('');
    const [empresaUuid, setEmpresaUuid] = useState('');

    const [txtBuscar,setTxtBuscar ] = useState('');

    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]); 

    const cuentax = new CuentasRequest();

    const handleRefresh = ()=> listar();

    //#region events
    const showSearchPopup = (event)=>{
        event.preventDefault();
        setIsOpenModal(true);
    }

    const handleChangeBusqueda = ({target})=>{
        const value = target.value;
       
        setTxtBuscar(value);
        if(value.length > 3){
          listar(value);
        }else if(value == ''){
          listar('');
        }
        
    }

    const onSelectedCuentaCurrent = (event, uuid)=>{
        onSelectedCuenta(uuid )
    }

    const onHandleOpenForm = (event)=>{
        setIsOpenModal(false);
    }

    const handleOnSelectedItem = (uuid, nombre_completo)=>{
        setIsOpenModal(false);
        setUuidSelected(uuid);
        setCustomerSelected(nombre_completo)
    
    }

    const handleClickMenu = (value) => {
        //console.log('padre1', value);
        onMenuSelecteItem(value);
    }

    //#endregion

    //#region methods
    function mostrar(uuid){
        cuentax.mostrarDetalle(uuid).then(({response})=>{
            setCuenta( value => response.data );
            setAlias(response.data.alias? response.data.alias : '' );
            setCustomerSelected(response.data.propietario);
            setUuidSelected(response.data.persona_uuid);
        });
    }

    const handleUpdateCuenta = (event)=>{
        event.preventDefault();
        const params = {
            alias: alias,
            cuenta_uuid: cuenta_uuid,
            persona_uuid: uuidSelected,
        };
        cuentax.update( JSON.stringify(params)  , cuenta_uuid ).then((response)=>{
            if(response.status == 'ok'){
                Swal.fire({
                    icon: 'success',
                    title: 'Notificaciones',
                    text: response.response.text,
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                  })
            }else{
                console.log('details');
            }
        });
    }

    const handleCancelarDetalle = ()=>{
        onCloseViewDetalle();
    }

      /* validacion en tiempo real de lo que se captura en los campos, marcar en rojo o verde segun lo que se esta ingresando */
    function getErrAlias(negative){
        if(negative){
            if(alias.length <= 3) return true;
            return false;
        }else{
            if(alias.length > 3) return true;
            return false;
        }
    }

  /* Nombres de los autorizadorees start   */
    function getErrCustomerSelected(negative){
        if(negative){
        if(customerSelected.length < 3) return true;
            return false;
        }else{
            if(customerSelected.length > 3 ) return true;
            return false;
        }
    }



  
  /* Nombres de los autorizadorees end   */

  //validacion otra vez todo de corrido
    function validate (){
        let hasError = false;
        let counter = 0;
        if(alias.length <= 3) { counter+=1; }
        if(uuidSelected.length == '') {counter+=1; }

        if(counter > 0){//XD no has capturado todo
        return (hasError = true);
        }
    
        return hasError;

    }
    //#endregion

    
    useEffect(()=>{
        mostrar( cuenta_uuid );
    },[]);

    return(
        <>
              <ModalBusqueda isOpen={isOpenModal} title="Buscar Cliente" onOpenForm={ (value)=>onHandleOpenForm(value) }
                    onSelectedItem = { (uuid, nombre_completo) => handleOnSelectedItem(uuid, nombre_completo) }
                />
            <SoftBox>
                <Card>
                    <Grid container pt={3}>
                        <Grid item xs={8} md={8} xl={5}>
                            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
                                <SoftTypography >Detalle de cuenta</SoftTypography>
                            </SoftBox>
                        </Grid>
                    </Grid>

                    <SoftBox pt={2} pb={3} px={3} component="form" role="form">
                        <Grid container spacing={2}>

                            <Grid item xs={12} md={4} xl={3}>
                                <SoftBox mb={1} lineHeight={0}>
                                    <SoftTypography variant="caption" color="text">
                                        Alias
                                    </SoftTypography>
                                </SoftBox>
                                <SoftBox> 
                                    <SoftInput placeholder="Nombre comercial" 
                                        maxLength="10" 
                                        error={ getErrAlias(true) } success={ getErrAlias(false)}
                                        value={alias} onChange={ e => setAlias(e.target.value) } autoComplete="off"
                                        
                                    />
                                </SoftBox>
                            </Grid>

                            <Grid item xs={12} md={6} xl={7}>
                                <SoftBox mb={1} lineHeight={0}>
                                    <SoftTypography variant="caption" color="text">
                                        Propietario
                                    </SoftTypography>
                                </SoftBox>
                                <SoftBox>
                                    <SoftInput type="test" placeholder="" 
                                    maxLength="10"  value = {customerSelected}
                                    autoComplete="off"
                                    disabled
                                    />
                                </SoftBox>
                            </Grid>

                            <Grid item xs={12} md={2} xl={2}>
                                <SoftBox pt={3} >
                                    <SoftButton fullWidth color="color5A"  onClick={showSearchPopup} >
                                        <IconSearch /> Buscar
                                    </SoftButton>
                                </SoftBox>
                            </Grid>

                            <Grid item xs={12} md={3} xl={3}>
                                <ButtonCancelarCuenta  key={cuenta.uuid+"x"} cuenta={cuenta}  />
                            </Grid>
                            <Grid item xs={12} md={3} xl={5}>
                                
                            </Grid>

                            <Grid item xs={12} md={3} xl={2}>
                                <SoftBox >
                                    <SoftButton fullWidth   color="color9"  onClick={ handleCancelarDetalle } >
                                        <IconBack /> Volver al Listado
                                    </SoftButton>
                                </SoftBox>
                            </Grid>

                            <Grid item xs={12} md={3} xl={2}>
                                <SoftBox >
                                    <SoftButton fullWidth color="color5V"  onClick={ handleUpdateCuenta } >
                                       <IconSave /> Actualizar información
                                    </SoftButton>
                                </SoftBox>
                            </Grid>
                        </Grid>
                    </SoftBox>

                    <ActionMenu onSelectedMenu = { (value) => handleClickMenu(value) } />
                    
                </Card>
            </SoftBox>
        </>
    )
    
}

CuentaDetalle.propTypes = {
    cuenta_uuid: PropTypes.string,
    onCloseViewDetalle: PropTypes.func,
    onMenuSelecteItem: PropTypes.func
};

export default CuentaDetalle;